import React from 'react'
import _ from 'lodash'

import CertificateRow from 'ui/components/ContainerCommonPanels/CertificateRow'

const infos = [
  {
    serviceId: 'ieptb_protests_registry_cpf',
    options: {
      fields: {
        registries: {
          name: 'Registros',
          fields: {
            name: 'Nome',
            uf: 'UF',
            city: 'Cidade',
            protests_number: 'Quantidade de protestos',
          },
        },
      },
    },
  },
  {
    serviceId: 'irregular_electoral_accounts_cpf',
    options: {
      fields: {
        processes: {
          name: 'Processos',
          fields: {
            process_identifier: 'Número do Processo',
            process_date: 'Data do Processo',
            city: 'Cidade',
            state: 'Estado',
            Cidade: 'Disponível em',
            process_link: 'Processo',
            record_link: 'Gravação',
            judgment_link: 'Julgamento',
          },
        },
      },
    },
  },
  {
    serviceId: 'irregular_accounts_cpf',
    options: {
      fields: {
        processes: {
          name: 'Processos',
          fields: {
            process_identifier: 'Número do Processo',
            process_date: 'Data do Processo',
            city: 'Cidade',
            state: 'Estado',
            Cidade: 'Disponível em',
            process_link: 'Processo',
            record_link: 'Gravação',
            judgment_link: 'Julgamento',
          },
        },
      },
    },
  },
  {
    serviceId: 'unabled_people_cpf',
    options: {
      fields: {
        processes: {
          name: 'Processos',
          fields: {
            process_identifier: 'Número do Processo',
            deliberation: 'Deliberação',
            judgment_date: 'Data do Julgamento',
            final_date: 'Data Final',
          },
        },
      },
    },
  },
  {
    serviceId: 'irregular_bidders_cpf',
    options: {
      fields: {
        processes: {
          name: 'Processos',
          fields: {
            process_identifier: 'Número do Processo',
            state: 'Estado',
            deliberation: 'Deliberação',
            judgment_date: 'Data do Julgamento',
            final_date: 'Data Final',
          },
        },
      },
    },
  },
  {
    serviceId: 'ceis_infos_government_base_cpf',
    options: {
      fields: {
        infos: {
          name: 'Infos',
          fields: {
            cpfcnpj: 'CPF',
            code: 'Código',
            reference_date: 'Data de referência',
            start_sanction_date: 'Início da Sanção',
            end_sanction_date: 'Final da Sanção',
            sanction_publication_date: 'Data de Publicação da Sanção',
            transited_judged_date: 'Data do transitado julgado',
            information_origin_date: 'Data de origem da informação',
            publication_text: 'Texto da publicação',
            publication_link: 'Link da publicação',
            publication_detail: 'Detalhes da publicação',
            process_number: 'Número do Processo',
            related_search: 'Pesquisas relacionadas',
            additional_information: 'Informações Adicionais',
          },
        },
      },
    },
  },
  {
    serviceId: 'cnep_infos_government_base_cpf',
    options: {
      fields: {
        infos: {
          name: 'Infos',
          fields: {
            cpfcnpj: 'CPF',
            code: 'Código',
            reference_date: 'Data de referência',
            start_sanction_date: 'Início da Sanção',
            end_sanction_date: 'Final da Sanção',
            sanction_publication_date: 'Data de Publicação da Sanção',
            transited_judged_date: 'Data do transitado julgado',
            information_origin_date: 'Data de origem da informação',
            sanction_type: 'Tipo de Sanção',
            source_sanction: 'Fonte da Sanção',
            legislation: 'Legislação',
            sanctioning_organ: 'Órgão da Sanção',
            sanctioned: 'Sancionado',
            publication_text: 'Texto da publicação',
            publication_link: 'Link da publicação',
            publication_detail: 'Detalhes da publicação',
            process_number: 'Número do Processo',
            related_search: 'Pesquisas relacionadas',
            additional_information: 'Informações Adicionais',
          },
        },
      },
    },
  },
]

const ExpansionPanelProtestsAccounts = ({ serviceInfos }) => {
  const renderServices = () => {
    return _.map(serviceInfos, (service) => {
      const info = _.find(infos, { serviceId: service.service_id })

      return (
        <CertificateRow
          key={service.service_id}
          title={service.name}
          service={service}
          otherInfos={info && _.get(service, 'data')}
          options={info && info.options}
        />
      )
    })
  }

  return (
    <ul style={{ listStyle: 'none', padding: 0, width: '100%' }}>
      {renderServices()}
    </ul>
  )
}

export default ExpansionPanelProtestsAccounts
